export default "__VITE_ASSET__CmD7b9eL__"